import { render, staticRenderFns } from "./order-rules-grid.vue?vue&type=template&id=4372776f&scoped=true"
import script from "./order-rules-grid.vue?vue&type=script&lang=js"
export * from "./order-rules-grid.vue?vue&type=script&lang=js"
import style0 from "./order-rules-grid.vue?vue&type=style&index=0&id=4372776f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4372776f",
  null
  
)

export default component.exports